package theme

import androidx.compose.runtime.*
import kotlinx.browser.document
import kotlinx.browser.window

@Composable
fun rememberThemeState(): MutableState<Boolean> {
    val isDark = remember {
        val saved = window.localStorage.getItem("theme")
        val prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches
        mutableStateOf(saved == "dark" || (saved == null && prefersDark))
    }

    LaunchedEffect(isDark.value) {
        val root = document.documentElement ?: return@LaunchedEffect
        if (isDark.value) {
            root.classList.add("dark")
            window.localStorage.setItem("theme", "dark")
        } else {
            root.classList.remove("dark")
            window.localStorage.setItem("theme", "light")
        }
    }

    return isDark
}
